import data from "./../../data.json";
import { normalizeVideoFxs } from "../constants";

export const popupComponentDefaultProps = {
  slowControl: 1,
  reverbAmount: 1,
  lowPassCutoff: 1000,
  highPassCutoff: 500,
  bitcrusherMode: false,
  bitcrusherAmount: 0.45,
  bassBoostMode: false,
  bassBoostAmount: 0.5,
  phaserMode: false,
  phaserAmount: 0.5,
  echoMode: false,
  echoAmount: 0.5,
  lofiHissVolume: 1,
  rainyMode: false,
  rainVolume: 0.6,
  coffeeShopMode: false,
  coffeeShopVolume: 0.6,
  seashoreMode: false,
  seashoreVolume: 0.6,
  vinylCrackleMode: false,
  vinylCrackleVolume: 0.55,
  preservePitchMode: false,
  videoFx: null,
  videoFxs: normalizeVideoFxs(data.videoFxs),
  isSlowedEnabled: false,
  contentApplying: false,
  musicProOnly: false,
  isHeaderVisible: true,
  isPro: false,
  isProFeaturesLocked: false,
  trialMode: false,
  trialEnded: false,
  shareMediaOptIn: false,
  testMode: false,
  paymentHookId: null,
  hookBusy: false,
  hookError: null,
  remainingTrialDays: 0,
  usageAvailable: false,
  usageHit: false,
  usageRemaining: 0,
  usageProgress: 0,
  debugMode: false,
  lowPassMode: false,
  highPassMode: false,
  lofiTapeMode: false,
  skin: "color",
  isFeedbackEnabled: false,
  isRateAppEnabled: false,
  isMoodEnabled: true,
  trackName: null,
  url: null,
  sharingStatus: null,
  onSlowedToggle: () => {},
  onUsageClick: () => {},
  onSlowControlChange: () => {},
  onVideoFxChange: () => {},
  onLowPassModeChange: () => {},
  onLofiTapeModeChange: () => {},
  onSkinChange: () => {},
  onReverbAmountChange: () => {},
  onLowPassCutoffChange: () => {},
  onHighPassModeChange: () => {},
  onHighPassCutoffChange: () => {},
  onBitcrusherModeChange: () => {},
  onBitcrusherAmountChange: () => {},
  onBassBoostModeChange: () => {},
  onBassBoostAmountChange: () => {},
  onPhaserModeChange: () => {},
  onPhaserAmountChange: () => {},
  onEchoModeChange: () => {},
  onEchoAmountChange: () => {},
  onLofiHissVolumeChange: () => {},
  onRainyModeChange: () => {},
  onRainVolumeChange: () => {},
  onCoffeeShopModeChange: () => {},
  onCoffeeShopVolumeChange: () => {},
  onSeashoreModeChange: () => {},
  onSeashoreVolumeChange: () => {},
  onVinylCrackleModeChange: () => {},
  onVinylCrackleVolumeChange: () => {},
  onPreservePitchModeChange: () => {},
  onAIShuffle: () => {},
  onClearMood: () => {},
  onMoodOpen: () => {},
  onMoodLockedClick: () => {},
  onCopyShareUrl: () => {},
  onCustomizeShortcut: () => {},
  onUpgradeClick: () => {},
  onFeedbackClick: () => {},
  onChangelogClick: () => {},
  onHelpClick: () => {},
  onRateAppClick: () => {},
  onResetProClick: () => {},
  onUsingUsageClick: () => {},
  onForceMaxUsageClick: () => {},
  onEndTrialModeClick: () => {},
  onShareMediaOptInChange: () => {},
  onTestModeChange: () => {},
  onRefreshPaymentHookClick: () => {},
  onStartTrialModeClick: () => {},
  onDebugModeChange: () => {},
  billingLoading: false,
  upgradeError: null,
  detachedPanel: false,
  onDetachedPanelChange: () => {},
  onResetControls: () => {},
  onManageSubscriptionClick: () => {},
  hideManagePlan: false,
};
